export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14898.a070cc42.jpg";